<template>
  <div class="model-box newsletter-h">
    <div class="title">
      <div class="ui-title">{{ modelData.title || 'Click to add title' }}</div>
    </div>

    <div class="hr"></div>

    <div class="img-list clearfix">
      <div class="ui-img-box">
        <div class="ui-img" v-if="modelData.img1">
          <div class="s-img" :style="'background-image: url(' + modelData.img1 + ');'"></div>
        </div>
        <div class="ui-img no-img" v-else>
          <div class="s-img">
            <img class="spbtn" src="@/assets/images/icons/add_photo_alternate.svg" />
          </div>
        </div>
      </div>

      <div class="ui-img-box">
        <div class="ui-img" v-if="modelData.img2">
          <div class="s-img" :style="'background-image: url(' + modelData.img2 + ');'"></div>
        </div>
        <div class="ui-img no-img" v-else>
          <div class="s-img">
            <img class="spbtn" src="@/assets/images/icons/add_photo_alternate.svg" />
          </div>
        </div>
      </div>

      <div class="ui-img-box">
        <div class="ui-img" v-if="modelData.img3">
          <div class="s-img" :style="'background-image: url(' + modelData.img3 + ');'"></div>
        </div>
        <div class="ui-img no-img" v-else>
          <div class="s-img">
            <img class="spbtn" src="@/assets/images/icons/add_photo_alternate.svg" />
          </div>
        </div>
      </div>
    </div>

    <div class="edit">
      <div
        v-if="modelData.edit && modelData.edit !== 'undefined'"
        v-html="htmlDecode(modelData.edit || '')"
        class="ui-edit"
        style="height: 57px; color: #3e556a; font-size: 13px"
      ></div>
      <div class="ui-edit no-edit" v-else>Click to add description</div>
    </div>

    <div class="img-list clearfix">
      <div class="ui-img-box">
        <div class="ui-img" v-if="modelData.img4">
          <div class="s-img" :style="'background-image: url(' + modelData.img4 + ');'"></div>
        </div>
        <div class="ui-img no-img" v-else>
          <div class="s-img">
            <img class="spbtn" src="@/assets/images/icons/add_photo_alternate.svg" />
          </div>
        </div>
      </div>

      <div class="ui-img-box">
        <div class="ui-img" v-if="modelData.img5">
          <div class="s-img" :style="'background-image: url(' + modelData.img5 + ');'"></div>
        </div>
        <div class="ui-img no-img" v-else>
          <div class="s-img">
            <img class="spbtn" src="@/assets/images/icons/add_photo_alternate.svg" />
          </div>
        </div>
      </div>

      <div class="ui-img-box">
        <div class="ui-img" v-if="modelData.img6">
          <div class="s-img" :style="'background-image: url(' + modelData.img6 + ');'"></div>
        </div>
        <div class="ui-img no-img" v-else>
          <div class="s-img">
            <img class="spbtn" src="@/assets/images/icons/add_photo_alternate.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { htmlDecode, formatImgData } from './../../utils/utils.js'

export default {
  components: {},
  props: {
    data: {
      default: () => ({}),
      type: Object
    },
    index: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      modelData: {}
    }
  },
  mounted() {},
  watch: {
    data: function () {
      this.modelData = this.formatImgData(this.data, 6)
    }
  },
  created() {
    this.modelData = this.formatImgData(this.data, 6)
  },
  methods: {
    htmlDecode,
    formatImgData
  }
}
</script>
<style lang="less">
@import '~@/assets/css/journalModel.less';
</style>
